import * as Sentry from '@sentry/browser';


if (USE_SENTRY) {
    Sentry.init(SENTRY_CFG);
}
